import { Box, Typography } from '@mui/joy';
import { MealIndicators } from './MealIndicators';

export function WeekdaySquare({ date, mealsAssigned, isToday, isSelected, onClick }) {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' }).slice(0, 3);
  const dayNumber = date.getDate();

  return (
    <Box
      onClick={onClick}
      sx={{        
        flex: 1,
        height: 56,
        borderRadius: 'md',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        position: 'relative',
        backgroundColor: isSelected ? 'var(--joy-palette-neutral-900)' : '#fff',
        color: isSelected ? '#fff' : 'var(--joy-palette-neutral-900)',
        '&:active': {
          transform: 'scale(0.95)',
        },
      }}
    >
      <Typography
        level="title-xs"
        sx={{
          position: 'absolute', top: 5,          
          fontSize: '9px',
          color: 'var(--joy-palette-neutral-600)',
        }}
      >
        {dayName}
      </Typography>
      <Typography        
        sx={{
          paddingTop: '6px',
          fontSize: '15px',
          lineHeight: '15px',
          fontWeight: 700,
          color: 'inherit',          
        }}
      >
        {dayNumber}
      </Typography>
      <MealIndicators mealsAssigned={mealsAssigned} isSelected={isSelected} />
    </Box>
  );
}

